
import React from "react";

import CleanUpDisk from "../component/CleanUpDisk";

const CleanUpDiskContainer = () => (<CleanUpDisk />)

export default CleanUpDiskContainer; 